import type { FrameworkClass } from '../framework/framework';
import { findFrameworkInitialization } from '../framework/frameworkInitialization';
import { replaceConstructorKwargInProgramCode } from './pythonSourceScanUtils';

/**
 * Updates a constructor kwarg in program source without touching the Monaco editor.
 * Used for drive-unit port parameters (`motor_port`, `sensor_port`, etc.) so we do not false-match `parentName.port` inside stream keys like `motor.port1.*`.
 */
export function replaceConstructorArgInProgramCode(
  code: string,
  lineNumber: number,
  parentName: string,
  parentClass: FrameworkClass | undefined,
  mechanismClass: FrameworkClass,
  parameterName: string,
  newValue: string
): string {
  const initParam = findFrameworkInitialization(parentClass, mechanismClass, parameterName);
  const argName = initParam?.constructor_arg;
  if (!argName || !parentName) return code;

  return replaceConstructorKwargInProgramCode(code, parentName, argName, newValue, lineNumber, mechanismClass.name);
}
